export * from "./blog/Blog"
export * from "./blogdetail/BlogDetail"
export * from "./serviceDetail/ServiceDetail"
export * from "./dockingmate/Dockingmate"
export * from "./general/General"
export * from "./about/About";
export * from "./howItWorks/HowItWorks";
export * from "./privacyPolicy/PrivacyPolicy";
export * from "./paymentSuccess/PaymentSuccess";
export * from "./paymentFailed/PaymentFailed";